import React from "react";
import Sidebar from "../../components/sidebar";
import Header from "../../components/header";
import { useRef, useState, useEffect } from "react";
import { Form, Button, Row, Col, Spinner, Table } from "react-bootstrap";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/AuthFetch";
import enableTableSearch from "../../utility/tableSearch";
import { Typeahead } from "react-bootstrap-typeahead";
import ExportHalfYearlyPDF from "../../utility/ExportHalfYearlyPdf";

function HalfYearly() {
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);

  const [loader, setLoader] = useState(false);

  const [standard, setStandard] = useState("");
  const [standardList, setStandardList] = useState([]);
  const [standardSelected, setStandardSelected] = useState(false);

  const [div, setDiv] = useState("");
  const [divList, setDivList] = useState([]);
  const [divSelected, setDivSelected] = useState(false);

  const [student, setStudent] = useState(null);
  const [studentSelected, setStudentSelected] = useState(false);
  const [studentList, setStudentList] = useState([]);

  const [standardLabel, setStandardLabel] = useState("");
  const [divisionLabel, setDivisionLabel] = useState("");

  const [marksData, setMarksData] = useState([]);
  const [maxMarksData, setMaxMarksData] = useState({});

  useEffect(() => {
    const fetchStandard = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/standard-options`
        );
        const result = await response.json();
        setStandardList(result.standard);
      } catch (error) {
        console.error("Error fetching Standard:", error);
      }
    };

    fetchStandard();
  }, []);

  const fetchDiv = async (standard) => {
    setDiv("");
    setDivSelected(false);
    setDivList([]);
    setStudentList([]);
    setStudentSelected(false);
    setStudent(null);
    if (standard === "") return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/div-options?standard=${standard}`
      );
      const result = await response.json();
      setDivList(result.division);
      setStandardSelected(true);
    } catch (error) {
      console.error("Error fetching patient:", error);
      setStandardSelected(false);
    }
  };

  const fetchStudents = async (div) => {
    setStudentList([]);
    if (div === "" || div === null) return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/student?standard=${standard}&div=${div}`
      );
      const result = await response.json();
      setStudentList(result.student);
      setDivSelected(true);

      setStandardLabel(
        standardList.find((s) => s.id === Number(standard))?.standard || ""
      );

      setDivisionLabel(
        divList.find((d) => d.id === Number(div))?.division || ""
      );
    } catch (error) {
      console.error("Error fetching patient:", error);
      setDivSelected(false);
    }
  };

  const fetchMarks = async (student) => {
    if (student === "" || student === null) return;
    try {
      const response = await authFetch(
        `${API_BASE_URL}/api/half-yearly?standard=${standard}&div=${div}&student=${student}`
      );
      const result = await response.json();
      setMarksData(result.result);
      setMaxMarksData(result.maxMarks);

      setStudentSelected(true);
    } catch (error) {
      console.error("Error fetching patient:", error);
      setStudentSelected(false);
    }
  };

  return (
    <div className="d-flex">
      {loader && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            backgroundColor: "rgba(193, 193, 193, 0.7)",
            zIndex: 2000,
            pointerEvents: "all",
          }}
        >
          <Spinner animation="border" variant="primary" />
        </div>
      )}

      <Sidebar sidebarCollapsed={sidebarCollapsed} />
      <div className="flex-grow-1">
        <Header setSidebarCollapsed={setSidebarCollapsed} />
        <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
          <div className="container bg-white p-4 rounded shadow-sm">
            <h5 className="mb-3">Half Yearly Report</h5>
            <Form>
              <Row className="align-items-end g-3">
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="formGrade">
                    <Form.Label>
                      Class <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="class"
                      required
                      value={standard}
                      onChange={(e) => {
                        const value = e.target.value;
                        setStandard(value);
                        fetchDiv(value);
                      }}
                    >
                      <option value="" disabled>
                        Select Class
                      </option>
                      {standardList?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.standard}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                {standardSelected && (
                  <>
                    <Col md={4}>
                      <Form.Group className="mb-3" controlId="formName">
                        <Form.Label>
                          Section <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Select
                          name="div"
                          value={div}
                          onChange={(e) => {
                            setDiv(e.target.value);
                            fetchStudents(e.target.value);
                          }}
                          required
                        >
                          <option value="" disabled>
                            Select Division
                          </option>
                          {divList?.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.division}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    {divSelected && (
                      <>
                        <Col md={4}>
                          <Form.Group className="mb-3" controlId="formStudent">
                            <Form.Label>
                              Student <span className="text-danger">*</span>
                            </Form.Label>

                            <Typeahead
                              id="student-typeahead"
                              labelKey="name"
                              options={studentList}
                              placeholder="Search Student"
                              clearButton
                              selected={student ? [student] : []}
                              onChange={(selected) => {
                                if (selected.length > 0) {
                                  setStudent(selected[0]);
                                  fetchMarks(selected[0].id);
                                } else {
                                  setStudent(null);
                                  setStudentSelected(false);
                                }
                              }}
                            />
                          </Form.Group>
                        </Col>

                        {studentSelected && (
                          <>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <Button
                                variant="success"
                                className="mb-3"
                                onClick={() =>
                                  ExportHalfYearlyPDF({
                                    student,
                                    standardLabel,
                                    divisionLabel,
                                    marksData,
                                    maxMarksData,
                                  })
                                }
                              >
                                Export PDF
                              </Button>
                            </div>
                            <Table striped bordered hover id="marksTable">
                              <thead>
                                <tr>
                                  <th
                                    rowSpan={2}
                                    style={{ verticalAlign: "middle" }}
                                  >
                                    SUBJECT
                                  </th>
                                  <th colSpan={2}></th>
                                  <th
                                    colSpan={5}
                                    style={{ textAlign: "center" }}
                                  >
                                    INTERNAL ASSESSMENT
                                  </th>
                                  <th
                                    colSpan={3}
                                    style={{ textAlign: "center" }}
                                  >
                                    HALF YEARLY EXAM
                                  </th>
                                </tr>
                                <tr>
                                  <th>PT 1</th>
                                  <th>PT 2</th>
                                  <th>CLASS WORK</th>
                                  <th>HOME WORK</th>
                                  <th>SUB ENRICHMENT</th>
                                  <th>DISCIPLINE</th>
                                  <th>CLASS INVOLVEMENT</th>
                                  <th>Marks Obtained</th>
                                  <th>GRADE</th>
                                </tr>
                                <tr>
                                  <th></th>
                                  <th>{maxMarksData.PT1}</th>
                                  <th>{maxMarksData.PT2}</th>
                                  <th>{maxMarksData.IA / 5}</th>
                                  <th>{maxMarksData.IA / 5}</th>
                                  <th>{maxMarksData.IA / 5}</th>
                                  <th>{maxMarksData.IA / 5}</th>
                                  <th>{maxMarksData.IA / 5}</th>
                                  <th>{maxMarksData.HY}</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {marksData.map((row, idx) => (
                                  <tr key={idx}>
                                    <td>{row.subjectName}</td>
                                    <td>{row.pt1}</td>
                                    <td>{row.pt2}</td>
                                    <td>{row.classWork}</td>
                                    <td>{row.homeWork}</td>
                                    <td>{row.subEnrichment}</td>
                                    <td>{row.discipline}</td>
                                    <td>{row.classInvolvement}</td>
                                    <td>{row.halfYearly}</td>
                                    <td>{row.grade}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HalfYearly;
